import React from "react";
import { FC } from "react";
import { DndProvider } from "react-dnd";
import DndBody from "./components/DndBody";
import { HTML5Backend } from "react-dnd-html5-backend";
import { CaDrugNDropItemType, onDropType } from "./types";

export type CaDrugAndDropProps = {
  data: CaDrugNDropItemType[];
  onDrop?: onDropType;
  disabled?: boolean;
  className?: string;
};

const CaDrugAndDrop: FC<CaDrugAndDropProps> = ({ data, onDrop, disabled, className }) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <DndBody data={data} onDrop={onDrop} disabled={disabled} className={className} />
    </DndProvider>
  );
};

export default CaDrugAndDrop;
